import api from '@api';

export const getAccounts = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/accounts?limit=1000`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getSender = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/senders?limit=1000`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getInbox = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/inbox`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getAudiences = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/audience-segments?limit=1000`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getAudienceByCategory = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/audience-segments/categories/${
        params?.category || 'INTERNAL.TEST'
      }?limit=1000`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getCampaignStatistic = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/twilio/campaign-messages/stats`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getTemplates = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/twilio/templates`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getTemplateLookup = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/twilio/templates?approvalStatus=approved&category=MARKETING&isActive=true&limit=1000`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};

export const getCampaignMessageByCampaignID = async ({
  token,
  id,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(
      `/admin/v3/messages/twilio/campaigns/${id}/messages`,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};
